// Faytex leadership — replace `image` with real headshots later.
// If image is null/empty, the UI falls back to a pink initials avatar.
export const FAYTEX_LEADERSHIP = [
  {
    id: "chadi-hage-ali",
    name: "Chadi Hage-Ali",
    role: "Production Director",
    bio: "Directs manufacturing strategy across the Kpone facility, translating decades of production expertise into modern, scalable operations.",
    image: "/chadi.webp",
  },
  {
    id: "bright-essien",
    name: "Bright Essien",
    role: "Finance and Strategy Director",
    bio: "Leads financial strategy and stewardship, ensuring Fay International grows on a foundation of disciplined, sustainable numbers.",
    image: "/bright.webp",
  },
  {
    id: "aaron-oko-quansah",
    name: "Aaron Oko Quansah",
    role: "Finance Manager",
    bio: "Oversees day-to-day financial operations, reporting and controls that keep Fay International running efficiently.",
    image: "/aaron.webp",
  },
  {
    id: "ethel-mankpaba-damma",
    name: "Ethel Mankpaba Damma",
    role: "HR and Admin Manager",
    bio: "Champions the people behind Faytex — from talent, training and welfare to the culture that makes the factory feel like family.",
    image: "/ethel.webp",
  },
  {
    id: "marian-awo-agbolo",
    name: "Marian Awo Agbolo",
    role: "Sales and Marketing Manager",
    bio: "Shapes the Faytex brand voice, community programmes and partnerships that keep the pink flag flying across Ghana.",
    image: "/marian.webp",
  },
  {
    id: "daniel-bortsie",
    name: "Daniel Bortsie",
    role: "Stock Manager",
    bio: "Manages raw materials and finished-goods inventory so every Faytex pack reaches shelves — and Market Queens — on time.",
    image: "/daniel.webp",
  },
  {
    id: "aliu-abdulahi",
    name: "Aliu Abdulahi",
    role: "Production Manager",
    bio: "Runs the production floor day-to-day, holding every Faytex pad to the quality standard Ghanaian women trust.",
    image: "/aliu.webp",
  },
];
